import { SNIPPET_REMOTE_ACTION_MAP_KEY } from 'flow/service/actionOptions';

export enum WorkflowEngineExceptionType {
  ERR_INITIALIZESCHEMA_NO_SCHEMA = 'ERR_INITIALIZESCHEMA_NO_SCHEMA',
  ERR_INITIALIZESCHEMA_FAILURE = 'ERR_INITIALIZESCHEMA_FAILURE',
}

export enum WorkflowTransformationIssueType {
  NO_MATCHING_TAG_FOUND_IN_CUSTOMER = 'NO_MATCHING_TAG_FOUND_IN_CUSTOMER',
  NO_MATCHING_SERVICE_FOUND_IN_CUSTOMER = 'NO_MATCHING_SERVICE_FOUND_IN_CUSTOMER',
  NO_MATCHING_OUTCOME_FOUND_IN_CUSTOMER = 'NO_MATCHING_OUTCOME_FOUND_IN_CUSTOMER',
  NO_TYPE_MATCHED = 'NO_TYPE_MATCHED',
  MATCHING_SERVICE_DISABLED_FOR_CUSTOMER = 'MATCHING_SERVICE_DISABLED_FOR_CUSTOMER',
  NO_MATCHING_LIST_ID_IN_CUSTOMER = 'NO_MATCHING_LIST_ID_IN_CUSTOMER',
  MATRIX_MODEL_NOT_SUPPORTED_AS_RHS_ACTION = 'MATRIX_MODEL_NOT_SUPPORTED_AS_RHS_ACTION',
}

export enum WorkflowImportUpdateResultType {
  RULE_UPDATED = 'RULE_UPDATED',
  EXPRESSION_UPDATED = 'EXPRESSION_UPDATED',
  LIST_ID_UPDATED = 'LIST_ID_UPDATED',
}

export enum WorkflowOperationType {
  UNDO_PERFORMED = 'UNDO_PERFORMED',
  AMBIGUOUS_RULE_FOUND = 'AMBIGUOUS_RULE_FOUND',
  CANCEL_PENDING_RULE_GROUP = 'CANCEL_PENDING_RULE_GROUP',
}

export const inputOutputAttributeActionOptionKeys = [
  'publishedAttributeToken',
  'name',
  'data_type',
  'use_jq',
  'jq_function',
];

export const outputAttributeActionOptionKeys = [
  'expression',
  'jq_function',
];

export const matrixModelActionOptionKeys = [
  'data_route_x',
  'data_route_y',
  'matrix_model_public_version',
  'matrix_model_token',
];

export const importedDataPassingActionOptionKeys = [
  'name',
  'display_name',
  'data_type',
  'use_jq',
];

export const snippetChildActionOptionKeys = [
  SNIPPET_REMOTE_ACTION_MAP_KEY,
];

export const booleanRuleStrings = {
  GROUP_START: '(',
  GROUP_END: ')',
  AND_OPERATOR: '&',
  OR_OPERATOR: '|',
  AND_OPERATOR_STRING: 'and',
  OR_OPERATOR_STRING: 'or',
};

export enum DependencyType {
  LEFT_SIDE_CONDITION = 'leftSideCondition',
  RIGHT_SIDE_CONDITION = 'rightSideCondition',
  DATA_ROUTE_SOURCE = 'dataRouteSource',
  // unused for now
  DATA_ROUTE_TARGET = 'dataRouteTarget',
}

// temporary re-exports to keep the existing Daffy import paths while these types move to policy-lib
export { ActionType } from '@usealloy/policy-lib/workflows';
export {
  AggregationType,
  AggregationTypeWithTimeframe,
  TimeframeUnit,
} from '@usealloy/policy-lib/workflows';

export enum ExpressionOperatorString {
  PLUS = '+',
  MINUS = '-',
  MULTIPLY = '*',
  DIVIDE = '/',
  // Infix despite reading as functions: stored between operands, e.g. [a, 'min', b, 'min', c].
  MIN = 'min',
  MAX = 'max',
}

// The operators a group can read as a function group
export const EXPRESSION_FUNCTIONS = [
  { operator: ExpressionOperatorString.MIN, name: 'Min' },
  { operator: ExpressionOperatorString.MAX, name: 'Max' },
];

export const EXPRESSION_FUNCTION_OPERATORS: string[] = EXPRESSION_FUNCTIONS
  .map(({ operator }) => operator);

const ARITHMETIC_OPERATORS: string[] = [
  ExpressionOperatorString.PLUS,
  ExpressionOperatorString.MINUS,
  ExpressionOperatorString.MULTIPLY,
  ExpressionOperatorString.DIVIDE,
];

export const EXPRESSION_OPERATORS: string[] = [
  ...ARITHMETIC_OPERATORS,
  ...EXPRESSION_FUNCTION_OPERATORS,
];

export enum MatrixModelDataType {
  NUMBER = 'number',
  STRING = 'string',
}

export const OUTPUT_CATEGORY_RISK_SCORING = 'Risk Scoring';
export const OUTPUT_CATEGORY_SESSION_RISK_SCORING = 'Session Risk Scoring';
